// eslint-disable-next-line import/no-cycle
import { getMaxLeverage } from '@/features/trade/order/utils/math';
import { getIsStatusFundedOrEval } from '@/features/vest-capital/utils/status';
import { useAccountStore } from '@/store/use-account-store';
import { getMarketStore } from '@/store/use-markets-store';

import { getFundedMaxLeverage } from './use-funded-account';

const MAX_REGULAR_LEVERAGE = 1000;

export const getDefaultLeverage = (symbol: string): number => {
  const { initMarginRatio } = getMarketStore(symbol).getState().marketSpec;
  const marketMax = getMaxLeverage(initMarginRatio);

  if (!marketMax) return 1;

  const { address, getCapitalStatus } = useAccountStore.getState();
  const capitalStatus = getCapitalStatus(address);
  const isFundedOrEval = getIsStatusFundedOrEval(capitalStatus);
  const fundedMax = getFundedMaxLeverage(symbol);

  return Math.min(
    Number(marketMax.decimal),
    isFundedOrEval ? fundedMax : MAX_REGULAR_LEVERAGE,
  );
};
